export default __webpack_public_path__ + "6fb52e6c6801ee57d2ae9b72b1e93669.svg";